import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Play } from "lucide-react";

// Design tokens
const colors = {
  primary: "hsl(var(--primary))",
  charcoal: "hsl(var(--foreground))",
  midGray: "hsl(var(--muted-foreground))",
  lightGray: "hsl(var(--muted))",
};

interface DemoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DemoModal: React.FC<DemoModalProps> = ({ isOpen, onClose }) => {
  // TODO: Replace with actual YouTube video ID when available
  const videoId = null; // e.g., "dQw4w9WgXcQ"

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[800px] p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-4">
          <DialogTitle
            className="text-2xl font-semibold"
            style={{ color: colors.charcoal }}
          >
            See TerraMatrix in Action
          </DialogTitle>
        </DialogHeader>

        <div className="px-6 pb-8">
          {/* Video Container - 16:9 aspect ratio */}
          <div
            className="relative w-full rounded-lg overflow-hidden"
            style={{
              aspectRatio: "16/9",
              backgroundColor: colors.lightGray,
            }}
          >
            {videoId ? (
              // Actual YouTube embed
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
                title="TerraMatrix Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              // Placeholder when no video is available
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                {/* Play button icon */}
                <div
                  className="w-20 h-20 rounded-full flex items-center justify-center mb-4"
                  style={{ backgroundColor: `${colors.primary}15` }}
                >
                  <div
                    className="w-16 h-16 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: colors.primary }}
                  >
                    <Play className="w-8 h-8 text-white ml-1" />
                  </div>
                </div>

                {/* Placeholder text */}
                <p
                  className="text-lg font-medium mb-2"
                  style={{ color: colors.charcoal }}
                >
                  Demo Video Coming Soon
                </p>
                <p
                  className="text-sm text-center max-w-md px-4"
                  style={{ color: colors.midGray }}
                >
                  We're putting the finishing touches on our product demo.
                  Check back soon to see TerraMatrix in action.
                </p>
              </div>
            )}
          </div>

          {/* Optional caption */}
          <p
            className="text-sm text-center mt-4"
            style={{ color: colors.midGray }}
          >
            See how TerraMatrix transforms IoT data into actionable insights
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
